import { useParams } from '@tanstack/react-router';
import { useIntlayer } from 'react-intlayer';

import {
  LawfulBasisSection,
  PrivacyHeader,
  SectionWithText,
  SectionWithLink,
} from './PrivacySections';

export const CookiePolicyPage = () => {
  const content = useIntlayer('cookies');
  const { locale } = useParams({ strict: false });

  return (
    <div className="relative min-h-screen bg-black text-white">
      {/* Main Content */}
      <div className="pt-40 md:pt-48 pb-80 px-4 md:px-8 lg:px-20">
        <div className="max-w-7xl mx-auto flex flex-col gap-14 md:gap-20">
          <PrivacyHeader date={content.date} title={content.title} />

          {/* Content - Offset to the right on desktop */}
          <div className="md:pl-[27rem] md:pr-28 flex flex-col gap-7 md:gap-10 text-white">
            <SectionWithText
              title={content.companyInfo.title}
              text={content.companyInfo.text}
            />

            <SectionWithLink
              title={content.introduction.title}
              beforeLink={content.introduction.beforeLink}
              linkText={content.introduction.linkText}
              linkTo={`/${locale}/privacy`}
              afterLink={content.introduction.afterLink}
            />

            <LawfulBasisSection
              title={content.definitions.title}
              intro=""
              items={content.definitions.items}
            />

            <LawfulBasisSection
              title={content.cookieTypes.title}
              intro={content.cookieTypes.intro}
              items={content.cookieTypes.items}
            />

            <SectionWithText
              title={content.consentControl.title}
              text={content.consentControl.text}
            />

            <SectionWithText
              title={content.thirdParty.title}
              text={content.thirdParty.text}
            />

            <SectionWithLink
              title={content.yourRights.title}
              beforeLink={content.yourRights.beforeLink}
              linkText={content.yourRights.linkText}
              linkTo={`/${locale}/privacy`}
              afterLink={content.yourRights.afterLink}
            />

            <div className="flex flex-col gap-1 text-sm text-gray-400">
              <p>{content.documentInfo.document}</p>
              <p>{content.documentInfo.revision}</p>
              <p>{content.documentInfo.revisionDate}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
